/**
 * Created by kachavas on 6/24/16.
 */
angular
  .module('ui-ng-ax')

  .constant('phxAxFocusDelegateConfiguration', {
    uniqueComponent: 'phx-ax-focus',
    vocabulary: {
      focus: function (scope, element, attrs, event, focusRequired) {
        if (focusRequired === attrs.phxAxFocus) {
          if (element[0].hasAttribute('tabindex')) {
            element.focus();
          } else {
            element
              .attr('tabindex', -1)
              .on('blur focusout', function () {
                element.removeAttr('tabindex');
              }).focus();
          }
        }
      }
    }
  })

  .directive('phxAxFocus', function phxFocusDirective(DelegateResponder, phxAxFocusDelegateConfiguration) {
    return {
      link: DelegateResponder(phxAxFocusDelegateConfiguration, function () {})
    };
  })

  .service('phxFocusDelegate', function phxFocusDelegate(DelegateController, phxAxFocusDelegateConfiguration) {
    DelegateController(this, phxAxFocusDelegateConfiguration);
  });



// WEBPACK FOOTER //
// phx_focus.js